import React, { useEffect, useState } from "react";
import {
  Typography,
  CircularProgress,
  Box,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";

const DollarWidget = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchRates = () => {
    setLoading(true);
    setError(false);
    fetch("https://economia.awesomeapi.com.br/json/last/USD-BRL,EUR-BRL")
      .then((res) => res.json())
      .then((json) => {
        setData(json);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Erro ao buscar cotação:", err);
        setError(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchRates();
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (error || !data) {
    return (
      <Box textAlign="center" p={2}>
        <Typography color="error" variant="body2">
          Falha ao carregar cotações.
        </Typography>
        <IconButton size="small" onClick={fetchRates} style={{ marginTop: 8 }}>
          <RefreshIcon fontSize="small" />
        </IconButton>
      </Box>
    );
  }

  const usd = data.USDBRL;
  const eur = data.EURBRL;

  const renderRate = (currency, item) => {
    if (!item) return null;
    const isPositive = parseFloat(item.pctChange) >= 0;
    return (
      <Box
        key={currency}
        style={{
          backgroundColor: "#ffffff",
          borderRadius: 8,
          padding: "8px 12px",
          marginBottom: 8,
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography variant="caption" style={{ color: "#666", fontWeight: "bold" }}>
            {currency === "USD" ? "🇺🇸 Dólar (USD)" : "🇪🇺 Euro (EUR)"}
          </Typography>
          <Typography variant="h6" style={{ fontWeight: "bold", color: "#2e7d32" }}>
            R$ {parseFloat(item.bid).toFixed(2)}
          </Typography>
        </Box>
        <Box textAlign="right">
          <Typography
            variant="caption"
            style={{
              fontWeight: "bold",
              color: isPositive ? "#2e7d32" : "#d32f2f",
            }}
          >
            {isPositive ? "▲" : "▼"} {item.pctChange}%
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <Box style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Typography variant="caption" style={{ color: "#777", fontWeight: 600 }}>
          Cotações Comercial em Tempo Real
        </Typography>
        <Tooltip title="Atualizar">
          <IconButton size="small" onClick={fetchRates}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {renderRate("USD", usd)}
      {renderRate("EUR", eur)}
    </Box>
  );
};

export default DollarWidget;
